import React from 'react';
import styled from 'styled-components';
import { Portal } from 'components';

const Container = styled.div`
	text-align: center;

	.row {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		margin-top: 10px;

		& > *:not(:last-child) {
			margin-right: 10px;
		}
	}
`;

const Description = styled.div`
	font-family: ${props => props.theme.pt};
	color: #333;
	font-size: 18px;
	line-height: 23px;
	margin-bottom: 10px;
`;

const Button = styled.div`
	width: 240px;
`;

export const ModalConfirm = ({ isVisible = false, text = '', title ='', confirmText = 'Да', cancelText = 'Нет', onConfirm = () => false, onCancel = () => false }) => {
	return (
		<Portal isOpen={isVisible} onClose={onCancel}>
			<Container className='flex column alignCenter'>
				
				{title.length > 0 && <h2>{title}</h2>}
				
				<Description>
					{text}
				</Description>
				
				<div className='row'>
					<Button className='button grad' onClick={onConfirm}>
						{confirmText}
					</Button>

					<Button className='button white' onClick={onCancel}>
						{cancelText}
					</Button>
				</div>
			</Container>
		</Portal>
	);
};
